import { Component, Input, OnInit } from '@angular/core';

@Component({
    template: `
        <span #dynamicInsert>
            <span data-toggle="tooltip" data-placement="top" [title]="context.rowData.length === 0 ? 'No results are available to export' : 'Export to Excel'">
                 <p-button id="buttonStyle" (click)="context.export()" [disabled]="context.rowData.length === 0">Export</p-button>
            </span>
            <span data-toggle="tooltip" data-placement="top" [title]="!context.enableSearch ? 'Missing criteria to retrieve data for report' : 'Get Report'">
                <p-button *ngIf="!context.report" id="buttonStyle" [disabled]="!context.enableSearch" (onClick)="context.retrieveData()"> Retrieve</p-button>
            </span>
            <p-button *ngIf="!context.report" id="buttonStyle" data-toggle="tooltip" data-placement="top" title="Reset Changes" (onClick)="context.resetPreferences()"> Reset</p-button>
        </span>
`,
styles:[
   `#buttonStyle {
        margin-left : 5px;
        
    }

   
    `
]
})
export class ReportModalHeaderComponent implements OnInit {
    @Input('incomingData') incomingData: any;
    context : any;
    constructor() {}
    ngOnInit() {
        this.context = Object.getPrototypeOf(this.incomingData);
    }
}